import fetch from "lib/fetch";
import type { VehicleTypeInterface } from "types/reference";

type VehicleTypeListResponse = { data: Array<VehicleTypeInterface> };

export const getVehicleTypesRequest = (languageCode: string) =>
    fetch.get<VehicleTypeListResponse>(`reference/vehicle_type/${languageCode}`);
